import React from "react";
import { DatePicker as AntDatePicker } from "antd";
import { TDatePicker, TRangePicker } from "./interface";

import "./index.less";

const RangePicker: TRangePicker = props => {
	return (
		<AntDatePicker.RangePicker
			format={props.datePattern}
			dropdownClassName="z-date-picker-dropdown"
			{...props}
		/>
	);
};

const DatePicker: TDatePicker = props => {
	return (
		<AntDatePicker
			format={props.datePattern}
			dropdownClassName="z-date-picker-dropdown"
			{...props}
		/>
	);
};

DatePicker.RangePicker = RangePicker;

export default DatePicker;
